import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { type FeedFlowItem } from '@src/services/interface';

type titleProps = {
    content: FeedFlowItem['title'];
};

const Title = ({ content }: titleProps) => {
    return content ? <div className={styles.title}>{content}</div> : null;
};

export default errorBoundary(Title);
